<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div :element-loading-text="loadText" class="panel" v-loading="loading">
      <custom-table
        :page="page"
        :selPage="selPage"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="pageHandle"
      >
        <div class="search-box" slot="search">
          <div class="select-type">
            <div @click="showBox = true" style="display:inline;">
              <i class="glyphicon glyphicon-question-sign"></i>
              <span v-text="language.statusText"></span>
            </div>
            <el-select @change="selectHandle" v-model="status">
              <el-option :key="k" :label="v" :value="k" v-for="(v,k) in language.status"></el-option>
            </el-select>
          </div>
          <div class="select-type">
            <span v-text="language.dateText"></span>
            <el-date-picker
              :end-placeholder="reuse.endTime"
              :picker-options="pickerOptions"
              :start-placeholder="reuse.startTime"
              style="width:220px;"
              type="daterange"
              unlink-panels
              v-model="dateRange"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="select-type">
            <el-button @click="filterHandle" type="primary" v-text="reuse.searchText"></el-button>
          </div>
          <div class="select-type">
            <div @click="export2Excel" class="btn btn-default">
              <i class="glyphicon glyphicon-save tab-he-glyphicon"></i>
              {{reuse.downloadExcelForms}}
            </div>
          </div>
        </div>
      </custom-table>
      <el-dialog :title="language.description" :visible.sync="showBox">
          <template v-for="(v,k) in language.status">
            <el-row :key="k" v-if="k >= 0">
                <el-col :span="2">{{v}}</el-col>
                <el-col
                    :span="22"
                >{{language.desc ? language.desc[k].replace(/start/g,start).replace(/end/g,end): '' }}</el-col>
            </el-row>
          </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_ANALYZE } from 'api/api'

const data = () => {
  return {
    tbodyData: [],
    allData: [],
    tmpData: [],
    loading: false,
    loadText: '',
    status: '-1',
    dateRange: [],
    showBox: false,
    pickerOptions: {
      disabledDate: function(time) {
        let now = new Date()
        now.setTime(now.getTime() - 24 * 36e5)
        return time.getTime() > now || time.getDay() === 6
      }
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    }
  }
}

const mixins = [require('common/mixin/base').base({ language: 'analyze' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  tableHead() {
    const redColorColumns = ['BALANCE']
    this.language.tableHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true;
    })
    return this.language.tableHead
  },
  start() {
    const [start] = this.dateRange || []
    return start || this.reuse.startTime
  },
  end() {
    const [, end] = this.dateRange || []
    return end || this.reuse.endTime
  }
}

const created = function() {
  const weekday = this.$moment().weekday()

  const defaultEnd = this.$moment()
    .subtract(weekday ? 1 : 2, 'd')
    .format('YYYY-MM-DD')
  const defaultStart = this.$moment()
    .subtract(weekday == 2 ? 4 : 3, 'd')
    .format('YYYY-MM-DD')
  this.dateRange.push(defaultStart)
  this.dateRange.push(defaultEnd)
  this.ajaxHandle()
}

const methods = {
  filterHandle() {
    this.page.active = 1
    this.ajaxHandle()
  },
  ajaxHandle() {
    this.loading = true
    this.$http
      .post(URL_ANALYZE, { date: this.dateRange })
      .then(res => {
        const useful = res.data.data
        if (Object.prototype.toString.call(useful.data) === '[object Array]') {
          this.allData = useful.data
          this.allData.forEach(v => (v.status = this.language.status[v.STATUS]))
          this.selectHandle()
        } else {
          this.$message.error(this.language[useful])
          this.tbodyData = []
          this.page.pageLeng = 0
        }
        if (res.data.msg !== 'OK') this.$message.error(this.reuse.invalidParam)
        this.loading = false
      })
      .catch(e => {
        alert(this.reuse.serverError)
      })
  },
  selectHandle() {
    this.page.active = 1
    this.tmpData = this.status > -1 ? this.allData.filter(v => v.STATUS == this.status) : this.allData
    this.pageHandle()
  },
  pageHandle() {
    const pageNum = this.page.active
    const pageSize = this.selPage.limit
    this.page.pageLeng = this.tmpData.length
    this.tbodyData = this.tmpData.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  },
  export2Excel() {
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/vendor/Export2Excel')
      const tHeader = this.tableHead.map(v => v.value)
      const filterVal = this.tableHead.map(v => v.key)
      const data = this.allData.map(v => filterVal.map(j => v[j]))
      const excelName = `${this.language.excelName}${this.dateRange ? `_${this.dateRange.map(v => v.replace(/-/g, '')).join('-')}` : ''}`
      export_json_to_excel(tHeader, data, excelName)
    })
  }
}

const components = {
  customTable
}

const watch = {
  language() {
    this.allData.forEach(v => (v.status = this.language.status[v.STATUS]))
  }
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components,
  watch
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/account-analyze-report.vue